import React, { Component } from 'react'
import ThemeManager from './ThemeManager';

export class BookingSingleOptionElement extends Component {

    constructor(props) {
        super(props);
        let themeManager = ThemeManager.getInstance();
        var _itemBackgroundColor = themeManager.getItemBackgroundColor();
        var _selectionColor = themeManager.getSelectionColor();
        var _mainTextColor = themeManager.getMainTextColor();
        var _buttonTextColor = themeManager.getButtonTextColor();

        var color = _itemBackgroundColor;
        var textColor = _mainTextColor;
        if (props.selected) {
            color = _selectionColor;
            textColor = _buttonTextColor;
        }

        this.state = {
            details: props.details,
            itemColor: color,
            itemTextColor: textColor,
            selected: props.selected
        };
    }


    static getDerivedStateFromProps(props, current_state) {
        let themeManager = ThemeManager.getInstance();
        var _itemBackgroundColor = themeManager.getItemBackgroundColor();
        var _selectionColor = themeManager.getSelectionColor();
        var _mainTextColor = themeManager.getMainTextColor();
        var _buttonTextColor = themeManager.getButtonTextColor();

        if (current_state.details.id !== props.details.id) {
            return {
                details: props.details,
                selected: false,
                itemColor: _itemBackgroundColor,
                itemTextColor: _mainTextColor,
            }
        }
        if (current_state.selected !== props.selected) {
            if (props.selected) {
                return {
                    selected: true,
                    itemColor: _selectionColor,
                    itemTextColor: _buttonTextColor,
                }
            } else if (!props.selected) {
                return {
                    selected: false,
                    itemColor: _itemBackgroundColor,
                    itemTextColor: _mainTextColor,
                }
            }
        }


        return null;
    }

    onItemHover = (e) => {

        if (!this.state.selected) {
            let themeManager = ThemeManager.getInstance();
            var _itemBackgroundColor = themeManager.getItemBackgroundColor();
            var _mainTextColor = themeManager.getMainTextColor();

            this.setState({ itemColor: _itemBackgroundColor + 'BA', itemTextColor: _mainTextColor });
        }

    }

    onItemLeave = (e) => {

        if (!this.state.selected) {
            let themeManager = ThemeManager.getInstance();
            var _itemBackgroundColor = themeManager.getItemBackgroundColor();

            this.setState({ itemColor: _itemBackgroundColor });
        }

    }

    onItemClick = (e) => {
        if (this.state.selected) {
            //this.setState({ itemColor: 'rgb(30,30,30)', selected: false});
            this.props.selectThis(this.props.slot, this.props.index, false);
        } else {
            //this.setState({ itemColor: 'rgb(255,194,0)', selected: true});
            this.props.selectThis(this.props.slot, this.props.index, true);
        }
    }

    render() {

        let themeManager = ThemeManager.getInstance();
        const _backgroundColor = themeManager.getBackgroundColor();
        const _selectionColor = themeManager.getSelectionColor();
        const _mainTextColor = themeManager.getMainTextColor();
        const _secondaryTextColor = themeManager.getSecondaryTextColor();
        const _itemBackgroundColor = themeManager.getItemBackgroundColor();
        const _buttonTextColor = themeManager.getButtonTextColor();
        const _errorColor = themeManager.getErrorColor();

        return (
            <div>
                <div style={{
                    marginRight: '7.5px', marginLeft: '7.5px', padding: '7.5px', minWidth: '100px', maxWidth: '120px', minHeight: '40px', backgroundColor: this.state.itemColor, borderRadius: '5px', color: this.state.itemTextColor, textAlign: 'center',
                    justifyContent: 'center', alignItems: 'center', display: 'flex', fontWeight: 'bold', cursor: 'pointer', fontSize: '13px', boxShadow: 'none', outline: 'none !important'
                }}
                    onMouseOver={this.onItemHover}
                    onMouseLeave={this.onItemLeave}
                    onClick={this.onItemClick} >
                    {this.state.details.element_name}
                </div>
            </div>
        )
    }
}

export default BookingSingleOptionElement
